export default Object.freeze({
	NetStamps: 'netstamps',
	ShippingLabel: 'shippingLabel',
	Envelope: 'envelope',
	CertifiedMail: 'cm',
	Roll: 'roll',
});
